import { Row } from "@components/Flex";
import { Body } from "@components/Typography";
import { usePerformanceChart } from "@hooks";
import { formatChartDateLabels } from "@utils";
import dayjs from "dayjs";
import { styles } from "./styles";

export const DateRangeValues = () => {
  const { selectedChart, selectedTimeRange } = usePerformanceChart();

  const nodes = selectedChart.nodes;

  const dateTimeValues = (() => {
    if (nodes.length === 0) return [];

    const middleIndex = Math.round(nodes.length / 2);

    return [
      dayjs(nodes[0].timestamp),
      dayjs(nodes[middleIndex].timestamp),
      dayjs(nodes[nodes.length - 1].timestamp),
    ];
  })();

  const dateRangeLabels = formatChartDateLabels({
    range: selectedTimeRange,
    dates: dateTimeValues,
  });

  return (
    <Row style={styles.container}>
      {dateRangeLabels?.map((dateTime, index) => (
        <Body key={index} style={{ ...styles.text, ...styles.light }}>
          {dateTime}
        </Body>
      ))}
    </Row>
  );
};
